import { useCommunity } from '@/lib/CommunityContext'

/** Whether the community measures with its own GA, the only cookie that needs a choice (F-201). */
export const useHasCookieChoice = () => {
  const { community } = useCommunity()
  return Boolean(community?.id && community.googleAnalyticsId?.trim())
}
